/**
 * Credit pack catalog — the single source of truth for pack sizes,
 * display prices, and the env-var names that hold their Stripe Price IDs.
 *
 * Env var names live here as DATA only; reading `process.env` happens in
 * the Convex layer (billingActions.ts). No env reads in domain/.
 */

import { err, ok, type Result } from "../shared/result";

export const PACK_IDS = ["PACK_5", "PACK_10", "PACK_20", "PACK_50"] as const;

export type PackId = (typeof PACK_IDS)[number];

export interface CreditPack {
  readonly credits: number;
  readonly priceUsd: number;
  readonly priceEnvVar: string;
}

export const CREDIT_PACKS: Record<PackId, CreditPack> = {
  PACK_5: { credits: 500, priceUsd: 5, priceEnvVar: "STRIPE_PRICE_PACK_5" },
  PACK_10: { credits: 1000, priceUsd: 10, priceEnvVar: "STRIPE_PRICE_PACK_10" },
  PACK_20: { credits: 2000, priceUsd: 20, priceEnvVar: "STRIPE_PRICE_PACK_20" },
  PACK_50: { credits: 5000, priceUsd: 50, priceEnvVar: "STRIPE_PRICE_PACK_50" },
};

export function isPackId(value: string): value is PackId {
  return (PACK_IDS as readonly string[]).includes(value);
}

export function getCreditPack({
  packId,
}: {
  packId: string;
}): Result<CreditPack, "unknown_pack"> {
  if (!isPackId(packId)) return err("unknown_pack");
  return ok(CREDIT_PACKS[packId]);
}

export const STANDARD_TIER = "standard" as const;

export const SUBSCRIPTION_PRICE_ENV_VAR = "STRIPE_PRICE_STANDARD_MONTHLY" as const;
